export default __webpack_public_path__ + "static/media/instaIcon.0b0dd3e0.svg";